var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfoCircle = function SvgInfoCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M10.606 19.25a9.25 9.25 0 1 0 0-18.5 9.25 9.25 0 0 0 0 18.5Z",
    stroke: "#858585",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.601 13.796v-4.42M10.601 6.204h.01",
    stroke: "#858585",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgInfoCircle as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMSAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTAuNjA2IDE5LjI0OThDMTUuNzE1IDE5LjI0OTggMTkuODU2IDE1LjEwNzggMTkuODU2IDkuOTk5NzZDMTkuODU2IDQuODkxNzYgMTUuNzE1IDAuNzQ5NzU2IDEwLjYwNiAwLjc0OTc1NkM1LjQ5Nzk2IDAuNzQ5NzU2IDEuMzU1OTYgNC44OTE3NiAxLjM1NTk2IDkuOTk5NzZDMS4zNTU5NiAxNS4xMDc4IDUuNDk3OTYgMTkuMjQ5OCAxMC42MDYgMTkuMjQ5OFoiIHN0cm9rZT0iIzg1ODU4NSIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPg0KPHBhdGggZD0iTTEwLjYwMTEgMTMuNzk1N1Y5LjM3NjY1IiBzdHJva2U9IiM4NTg1ODUiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4NCjxwYXRoIGQ9Ik0xMC42MDEgNi4yMDM4NkgxMC42MTEiIHN0cm9rZT0iIzg1ODU4NSIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPg0KPC9zdmc+DQo=";